import { Component } from '@angular/core';

@Component({
  selector: 'om-svg-exclamation',
  templateUrl: './svg-exclamation.component.html',
})
export class SvgExclamationComponent {
  constructor() {}
}
